<template>
  <div class="navbar-container">
    <b-navbar type="dark" class="navbar-subcontainer">
      <b-navbar-nav class="brand-container">
        <b-navbar-brand class="brand" href="#" @click="toHome()">
          <img src="../../../assets/img/isupplier-logo.png" class="img-logo" alt="" />
        </b-navbar-brand>
      </b-navbar-nav>
      <div class="navbar-menu">
        <div class="user-indicator">
          <div class="user-icons" @click="checkNotif">
            <strong class="text-white"><span class="total-notif">{{ total_notif }}</span><i class="fas fa-bell"></i>
            </strong>
            <!-- <p class="total-notif"></p> -->
          </div>
          <div class="user-name-wrapper">
            <div style="cursor:pointer" @click="showLogin()" v-if="!$get($store, 'state.token')">
              Login
            </div>
            <div class="user-name" v-if="$get($store, 'state.token')">
              {{ $get($store, 'state.currentUser') }}
            </div>
            <div class="user-role" style="cursor:pointer" v-if="$get($store, 'state.token')" @click="logout">
              Logout
            </div>
            <!-- <div class="user-role">Administrator</div> -->
          </div>
        </div>
        <div class="input-search">
          <b-input-group>
            <template #append>
              <b-input-group-text class="bg-sinarmas-danger">
                <strong class="text-white">
                  <i class="fas fa-times" style="cursor:pointer; marginRight: 10px" @click="deleteSearch()"
                    v-if="vendorName !== '' && vendorName"></i>
                  <i class="fas fa-search" style="cursor:pointer" @click="searchByName()"></i>
                </strong>
              </b-input-group-text>
            </template>
            <b-form-input placeholder="Nama Vendor / Kode KBLI" v-model="vendorName"
              @keydown.native="enterForSearch"></b-form-input>
          </b-input-group>
        </div>
        <div class="menu-list">
          <!-- <div class="dropdown" @click="goDashboard()">
            <button class="dropbtn">
              <i class="lni lni-dashboard mr5"></i>Dashboard<i class="fas fa-caret-down ml5"></i>
            </button>
            <div class="dropdown-content">
              <a href="#">Link 1</a>
              <a href="#">Link 2</a>
              <a href="#">Link 3</a>
            </div>
          </div> -->
          <div class="dropdown">
            <i class="lni lni-dashboard mr5"></i>Dashboard<i class="fas fa-caret-down ml5"></i>
            <div class="dropdown-content">
              <a @click="goTKDN()" v-if="$get($store, 'state.permissions.3.allow')">TKDN</a>
              <a @click="goDashboarVA()" v-if="$get($store, 'state.permissions.3.allow')">Vendor Analytic</a>
              <a @click="goDashboarKPI()" v-if="$get($store, 'state.permissions.3.allow')">KPI</a>
              <a @click="goDashboarMonitoring()" v-if="$get($store, 'state.permissions.3.allow')">Monitoring</a>
            </div>
          </div>
          <a @click="goMyRequest()"><i class="lni lni-pencil mr5"></i>My Request</a>
          <a @click="goApproval()"><i class="lni lni-checkmark-circle mr5"></i>Approval Sheet</a>
          <a @click="goUserRole()"><i class="fas fa-cog mr5"></i>User Role Setting
            <!-- <i class="fas fa-caret-down ml5"></i> -->
          </a>
          <div class="dropdown">
            <i class="lni lni-dashboard mr5"></i>Master Data<i class="fas fa-caret-down ml5"></i>
            <div class="dropdown-content">
              <a @click="goMasterData()"><i class="lni lni-database mr5"></i>Landing Page Dinamis</a>
              <a @click="goMasterDataDatabase()"><i class="lni lni-database mr5"></i>Database</a>
              <a @click="goMasterDataMatrixLegal()"><i class="lni lni-database mr5"></i>Matrix Legal Document</a>
              <a @click="exportToExcel()"><i class="far fa-file mr5"></i>Export to Excel Data Vendor</a>
              <a @click="exportToExcelK3L()"><i class="far fa-file mr5"></i>Export to Excel Data K3L</a>
              <a @click="exportToExcelKPLH()"><i class="far fa-file mr5"></i>Export to Excel Data KPLH</a>
            </div>
          </div>
          <a @click="docReminder()"><i class="far fa-file mr5"></i>Doc Reminder</a>
          <a @click="showSearchModal()"><i class="fas fa-search mr5"></i>Advance Search</a>
        </div>
      </div>
    </b-navbar>
  </div>
</template>

<script>
import axios from 'axios'
import { api } from '@/services/config'
import * as XLSX from 'sheetjs-style'
export default {
  name: 'Navbar',
  data() {
    return {
      // vendorName: ''
    }
  },
  created() {
    this.$store.dispatch('notifStore/getNotifications', {
      id: this.$store.state.role_id,
    })
  },
  computed: {
    vendorName: {
      get: function () {
        return this.$store.state.searchStore.vendorName
      },
      set: function (newValue) {
        this.$store.commit('searchStore/SET_SEARCH_VALUE', {
          name: 'vendorName',
          value: newValue,
        })
      },
    },
    total_notif: {
      get: function () {
        return this.$store.state.notifStore.total_notif
      },
    },
  },
  methods: {
    checkNotif() {
      this.$router.push('/notifications')
    },
    showLogin() {
      this.$store.commit('SET_MODAL_LOGIN', true)
    },
    async logout() {
      await this.$store.dispatch('logout')
      await this.$store.commit('AUTO_LOGIN')
      await this.$router.push({ name: 'home' }, () => { })
    },
    async toHome() {
      await this.$store.commit('editingStore/CLEAR_EDITING', {
        user_id: this.$store.state.userid,
      })
      await this.$store.commit('modalStore/SET_MODAL_LEVEL1', false)
      await this.$store.dispatch('level1/setLevel1Page', 1)
      await this.$store.commit('searchStore/RESET_FILTER')
      await this.$store.commit('level1/RESET_QUERY')
      await this.$router.push('/')
    },
    showSearchModal() {
      if (this.$get(this.$store, 'state.permissions.12.allow')) {
        this.$store.commit('searchStore/SHOW_MODAL', true)
      } else {
        this.$store.commit('DONT_HAVE_PERMISSIONS')
      }
    },
    enterForSearch(event) {
      if (event.which === 13) {
        this.searchByName()
      }
    },
    async searchByName() {
      const vendorName =
        this.vendorName !== '' || this.vendorName
          ? `&search=${this.vendorName}`
          : ''

      this.$gtag.pageview({
        page_title: 'Level 1',
        role: this.$store.state.rolename,
        user: this.$store.state.userinit,
        search: vendorName,
      })

      await this.$store.commit('modalStore/SET_REQ_NEW_VENDOR_MODAL', false)
      await this.$store.commit('modalStore/SET_MODAL_LEVEL1', false)
      await this.$store.dispatch('level1/setLevel1Page', 1)
      await this.$store.commit('level1/SET_DATA_LEVEL1', {
        query: { vendorName },
      })
      if (this.$route.path !== '/level1') {
        await this.$router.push({ path: '/level1' })
      }
    },
    async deleteSearch() {
      await this.$store.commit('searchStore/SET_SEARCH_VALUE', {
        name: 'vendorName',
        value: '',
      })
    },
    goDashboard() {
      this.$store.commit('SET_NOTIF', 'Maaf, Fitur sedang dalam pengembangan.')
    },
    goTKDN() {
      this.$gtag.pageview({
        page_title: 'Dashboard TKDN',
        role: this.$store.state.rolename,
        user: this.$store.state.userinit,
      })
      if (this.$get(this.$store, 'state.permissions.3.allow')) {
        this.$router.push({ path: '/dashboard' })
      } else {
        this.$store.commit('DONT_HAVE_PERMISSIONS')
      }
    },
    goDashboarVA() {
      this.$gtag.pageview({
        page_title: 'Dashboard VA',
        role: this.$store.state.rolename,
        user: this.$store.state.userinit,
      })
      if (this.$get(this.$store, 'state.permissions.3.allow')) {
        this.$router.push({ path: '/dashboard-va' })
      } else {
        this.$store.commit('DONT_HAVE_PERMISSIONS')
      }
    },
    goDashboarKPI() {
      this.$gtag.pageview({
        page_title: 'Dashboard KPI',
        role: this.$store.state.rolename,
        user: this.$store.state.userinit,
      })
      if (this.$get(this.$store, 'state.permissions.3.allow')) {
        this.$router.push({ path: '/kpi' })
      } else {
        this.$store.commit('DONT_HAVE_PERMISSIONS')
      }
    },
    goDashboarMonitoring() {
      if (this.$get(this.$store, 'state.permissions.3.allow')) {
        this.$router.push({ path: '/monitoring' })
      } else {
        this.$store.commit('DONT_HAVE_PERMISSIONS')
      }
    },
    goUserRole() {
      this.$gtag.pageview({
        page_title: 'User Role',
        role: this.$store.state.rolename,
        user: this.$store.state.userinit,
      })
      if (this.$get(this.$store, 'state.permissions.9.allow')) {
        this.$router.push({ path: '/user-role' })
      } else {
        this.$store.commit('DONT_HAVE_PERMISSIONS')
      }
    },
    goMasterData() {
      this.$gtag.pageview({
        page_title: 'Masterdata Landing Page Dinamis',
        role: this.$store.state.rolename,
        user: this.$store.state.userinit,
      })
      if (this.$get(this.$store, 'state.permissions.3.allow')) {
        this.$router.push({ path: '/md-landingpage' })
      } else {
        this.$store.commit('DONT_HAVE_PERMISSIONS')
      }
    },
    goMasterDataDatabase() {
      this.$gtag.pageview({
        page_title: 'Masterdata Database',
        role: this.$store.state.rolename,
        user: this.$store.state.userinit,
      })
      if (this.$get(this.$store, 'state.permissions.3.allow')) {
        this.$router.push({ path: '/masterdata-database' })
      } else {
        this.$store.commit('DONT_HAVE_PERMISSIONS')
      }
    },
    goMasterDataMatrixLegal() {
      this.$gtag.pageview({
        page_title: 'Masterdata Matrix Legal',
        role: this.$store.state.rolename,
        user: this.$store.state.userinit,
      })
      if (this.$get(this.$store, 'state.permissions.3.allow')) {
        this.$router.push({ path: '/matrix-legal' })
      } else {
        this.$store.commit('DONT_HAVE_PERMISSIONS')
      }
    },
    async exportToExcel() {
      try {
        this.$store.commit('level1/SET_LOADING', true)
        const { data } = await axios.get(`${api}/api/v1/vendor`)

        if (data.status == 'success') {
          const refactorData = data.data.map((item, index) => {
            return {
              no: index + 1,
              badan_usaha: this.$get(item, 'badan_usaha.alias_profile', '-'),
              nama_vendor: item.nama_vendor,
              tanggal_berdiri: item.tanggal_berdiri,
              alamat: item.alamat,
              negara: this.$get(item, 'negara.negara', '-'),
              provinsi: this.$get(item, 'provinsi.desc', '-'),
              provinsi_asing: item.provinsi_asing,
              kota: this.$get(item, 'kota.desc', '-'),
              kota_asing: item.kota_asing,
              kecamatan: this.$get(item, 'kecamatan.desc', '-'),
              kelurahan: this.$get(item, 'kelurahan.desc', '-'),
              kode_pos_asing: item.kode_pos_asing,
              no_handphone: item.no_handphone,
              email: item.email,
              nama_pemilik_rekening: item.nama_pemilik_rekening,
              bank: item.bank,
              kantor_cabang: item.kantor_cabang,
              no_rekening: item.no_rekening,
              mata_uang: item.mata_uang,
              no_npwp: item.no_npwp,
              afiliasi_bce: item.afiliasi_bce ? 'YA' : 'TIDAK',
              afiliasi_gems: item.afiliasi_gems ? 'YA' : 'TIDAK',
              afiliasi_bkes: item.afiliasi_bkes ? 'YA' : 'TIDAK',
              ariba_code: item.ariba_code,
              bce_code: item.bce_code,
              gems_code: item.gems_code,
              bkes_code: item.bkes_code,
              isupplier_code: item.isupplier_code,
              status: item.status ? 'AKTIF' : 'TIDAK AKTIF',
              request_id: item.request_id,
              statusLegal: item.statusLegal,
              expireLegal: item.expireLegal,
              createdAt: this.formatDateTime(item.createdAt),
              updatedAt: this.formatDateTime(item.updatedAt),
              deletedAt: this.formatDateTime(item.deletedAt),
            }
          });


          const ws = XLSX.utils.json_to_sheet(refactorData)
          const wb = XLSX.utils.book_new()
          XLSX.utils.book_append_sheet(wb, ws, 'Sheet1')
          XLSX.writeFile(wb, 'Data Vendor.xlsx')
          this.$store.commit('level1/SET_LOADING', false)
        } else {
          throw new Error('Export Data Vendor Gagal')
        }
      } catch (error) {
        this.$store.commit('level1/SET_LOADING', false)
        this.$store.commit('SET_NOTIF', 'Export Data Vendor Gagal')
      }
    },
    async exportToExcelK3L() {
      try {
        this.$store.commit('level1/SET_LOADING', true)
        const { data } = await axios.get(`${api}/api/v1/d-vendor-k3l`)

        if (data.status == 'success') {
          const refactorData = data.data.map((item, index) => {
            return {
              no: index + 1,
              vendor: this.$get(item, 'vendor.nama_vendor', '-'),
              nilai: item.nilai,
              keterangan: item.keterangan,
              tanggal_efektif: item.tanggal_efektif,
              tanggal_berakhir: item.tanggal_berakhir,
              pic: item.pic,
              last_reviewer: item.last_reviewer,
              attachment: item.attachment,
              update_by: item.update_by,
            }
          })


          const ws = XLSX.utils.json_to_sheet(refactorData)
          const wb = XLSX.utils.book_new()
          XLSX.utils.book_append_sheet(wb, ws, 'Sheet1')
          XLSX.writeFile(wb, 'Data K3L.xlsx')
          this.$store.commit('level1/SET_LOADING', false)
        } else {
          throw new Error('Export Data K3L Gagal')
        }
      } catch (error) {
        this.$store.commit('level1/SET_LOADING', false)
        this.$store.commit('SET_NOTIF', 'Export Data K3L Gagal')
      }
    },
    async exportToExcelKPLH() {
      try {
        this.$store.commit('level1/SET_LOADING', true)
        const { data } = await axios.get(`${api}/api/v1/d-vendor-kplh`)

        if (data.status == 'success') {
          const refactorData = data.data.map((item, index) => {
            return {
              no: index + 1,
              vendor: this.$get(item, 'vendor.nama_vendor', '-'),
              nilai: item.nilai,
              keterangan: item.keterangan,
              tingkat_resiko: item.tingkat_resiko,
              tanggal_efektif: item.tanggal_efektif,
              tanggal_berakhir: item.tanggal_berakhir,
              pic: item.pic,
              last_reviewer: item.last_reviewer,
              attachment: item.attachment,
              update_by: item.update_by,
            }
          })

          const ws = XLSX.utils.json_to_sheet(refactorData)
          const wb = XLSX.utils.book_new()
          XLSX.utils.book_append_sheet(wb, ws, 'Sheet1')
          XLSX.writeFile(wb, 'Data KPLH.xlsx')
          this.$store.commit('level1/SET_LOADING', false)
        } else {
          throw new Error('Export Data KPLH Gagal')
        }
      } catch (error) {
        this.$store.commit('level1/SET_LOADING', false)
        this.$store.commit('SET_NOTIF', 'Export Data KPLH Gagal')
      }
    },
    docReminder() {
      if (this.$store.state.role_id == 1 || this.$store.state.role_id == 2) {
        this.$gtag.pageview({
          page_title: 'Document Notif',
          role: this.$store.state.rolename,
          user: this.$store.state.userinit,
        })
        this.$router.push({ path: '/document-notif' })
      } else {
        this.$store.commit('DONT_HAVE_PERMISSIONS')
      }
    },
    goMyRequest() {
      this.$gtag.pageview({
        page_title: 'My Request',
        role: this.$store.state.rolename,
        user: this.$store.state.userinit,
      })
      if (this.$get(this.$store, 'state.permissions.6.allow')) {
        this.$router.push({ path: '/myrequest' })
      } else {
        this.$store.commit('DONT_HAVE_PERMISSIONS')
      }
    },
    goApproval() {
      this.$gtag.pageview({
        page_title: 'Approval Sheet',
        role: this.$store.state.rolename,
        user: this.$store.state.userinit,
      })
      if (this.$get(this.$store, 'state.permissions.7.allow')) {
        this.$router.push({ path: '/approval' })
      } else {
        this.$store.commit('DONT_HAVE_PERMISSIONS')
      }
      // this.$router.push({ path: '/approval' })
    },
  },
}
</script>

<style lang="scss" scoped>
@import '~/assets/scss/components/navbar.scss';
</style>
